import { render, staticRenderFns } from "./Limit.vue?vue&type=template&id=276eac5a&"
import script from "./Limit.vue?vue&type=script&lang=ts&"
export * from "./Limit.vue?vue&type=script&lang=ts&"
import style0 from "@/styles/landing/auth.scss?vue&type=style&index=0&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports